/* global $ */

import equaliseRows from './equaliseRows'
import initialiseNavMenu from './submenu'


function setTitleColors() {
    $('.intro_text, .simple_stat').each(function() {
        var color = $(this).attr('data-color');
        if (color) {
            $(this).find('b').css('color', color);
        }
    });
}

function lightbox() {
    $('.lightbox').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true,
        },
    });
}

function intro() {
    $('.intro_wrapper').owlCarousel({
        navigation: true,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseElement: window,
        slideSpeed: 200,
        addClassActive: true,
        paginationSpeed: 200,
        rewindSpeed: 200,
        singleItem: true,
        autoPlay: false,
        transitionStyle: 'fade',
        afterAction: function(elem) {
            $('.active .tlt').textillate('start');
        },
        navigationText: [
            '<i class="fa fa-angle-left"></i>',
            '<i class="fa fa-angle-right"></i>',
        ],
    });
}

function filmStrip() {
    $('.film_wrapper').owlCarousel({
        navigation: true,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseElement: window,
        slideSpeed: 200,
        addClassActive: true,
        paginationSpeed: 200,
        rewindSpeed: 200,
        autoPlay: true,
        transitionStyle: 'fade',
        items: 6,
        navigationText: [
            '<i class="fa fa-angle-left"></i>',
            '<i class="fa fa-angle-right"></i>',
        ],
    });
}

function letteriseLogo() {
    if ($(window).width() > 992) {
        $('header .logo a b').lettering();
        $('header .logo span').each(function() {
            var min = 0;
            var max = 50;
            var randomNumber = Math.floor(Math.random() * (max - min + 1) + min);
            $(this).css('transition-delay', '0.' + randomNumber + 's');
        });
    }
}

function setBackgrounds() {
    $('.image_bck, .over, .head_bck').each(function() {
        var $this = $(this);

        var image = $this.attr('data-image');
        var gradient = $this.attr('data-gradient');
        var color = $this.attr('data-color');
        var blend = $this.attr('data-blend');
        var opacity = $this.attr('data-opacity');
        var position = $this.attr('data-position');

        if (image) {
            $this.css('background-image', 'url(' + image + ')');
        }

        if (gradient) {
            $this.css('background-image', gradient);
        }

        if (color) {
            $this.css('background-color', color);
        }

        if (blend) {
            if($this.is('.over, .head_bck')) {
                $(this).css('mix-blend-mode', blend);
            } else {
                $this.css('background-blend-mode', blend);
            }
        }

        if (position) {
            $this.css('background-position', position);
        }

        if (opacity) {
            $this.css('opacity', opacity);
        }
    });
}

function siteReflow() {
    initialiseNavMenu()
    setTitleColors()
    setBackgrounds()
    letteriseLogo()
    equaliseRows()
    lightbox()
    intro()
    filmStrip()
}

export default siteReflow;



// WEBPACK FOOTER //
// ./src/modules/plugins/siteReflow.js